import type { ClientResponse, OrderPagedQueryResponse } from '@commercetools/platform-sdk';

import type { ApiClientDetails } from '../../types';

export function ordersApi({ apiRoot }: ApiClientDetails) {
    async function searchOrdersBetweenDates(
        country: string,
        start: string,
        end: string,
        limit: number,
        offset: number
    ): Promise<ClientResponse<OrderPagedQueryResponse>> {
        return apiRoot()
            .orders()
            .get({
                queryArgs: {
                    where: 'createdAt >= :start AND createdAt < :end AND country = :country',
                    'var.start': start,
                    'var.end': end,
                    'var.country': country,
                    limit,
                    offset,
                },
            })
            .execute();
    }

    return {
        searchOrders: searchOrdersBetweenDates,
    };
}
